var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Tool page for administration of wenewz, May be integrated as a component later.. Will see.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }